module.exports = __webpack_public_path__ + "img/1746615260_y6rQ.9735df75.png";